import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function RequiredLabel({ text }) {
    return (
        <Box component="span">
            {text}
            <Box component="span" sx={{ color: 'red' }}>*</Box>
        </Box>
    )
};


RequiredLabel.propTypes = {
    text: PropTypes.string,
};